export class TimeWorker {
  static dateDiffInSec = (d1, d2) => {
    const t2 = new Date(d2).getTime();
    const t1 = new Date(d1).getTime();
    return Math.floor((t2 - t1) / 1000);
  };
  static dateDiffInMinute = (d1, d2) => {
    const t2 = new Date(d2).getTime();
    const t1 = new Date(d1).getTime();
    return Math.floor((t2 - t1) / (60 * 1000));
  };
  static dateDiffInHour = (d1, d2) => {
    const t2 = new Date(d2).getTime();
    const t1 = new Date(d1).getTime();
    return Math.floor((t2 - t1) / (3600 * 1000));
  };
  static dateDiffInDay = (d1, d2) => {
    const t2 = new Date(d2).getTime();
    const t1 = new Date(d1).getTime();
    return Math.floor((t2 - t1) / (24 * 3600 * 1000));
  };
  static dateDiffInWeek = (d1, d2) => {
    const t2 = new Date(d2).getTime();
    const t1 = new Date(d1).getTime();
    return (t2 - t1) / (24 * 3600 * 1000 * 7);
  };
  static dateDiffInMonth = (d1, d2) => {
    const d1Y = new Date(d1).getFullYear();
    const d2Y = new Date(d2).getFullYear();
    const d1M = new Date(d1).getMonth();
    const d2M = new Date(d2).getMonth();
    return d2M + 12 * d2Y - (d1M + 12 * d1Y);
  };
  static padWithZero(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }
  static formatSecondToHour(seconds = 0) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;
    return `${this.padWithZero(hours)}:${this.padWithZero(minutes)}:${this.padWithZero(remainingSeconds)}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/utils/timeWorker.ts